import { Grid, useMediaQuery } from "@mui/material";
import { usePostHog } from "posthog-js/react";
import { useEffect, useState } from "react";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import content_my from "./content_my.json";
import content_sg from "./content_sg.json";
import {
  GridStyledHireBetter,
  HireBetterButtonContainer,
  HireBetterCard,
  HireBetterCTA,
  HireBetterEventDescription,
  HireBetterEventHeadline,
  HireBetterEventName,
  HireBetterImage,
  HireBetterOuterCard,
  HireBetterUpperContainer,
} from "./styles";

export default function EmployerHireBetterNew() {
  const [data, setData] = useState([]);

  const belowTablet = useMediaQuery("(max-width: 767px)");

  function fetchData() {
    // use s3 json for staging testing
    // const content_my_json = await fetchJsonData(
    //   "https://assets.hiredly.com/cms-staging/json-file/event_banner_content_my.json"
    // );

    // const content_sg_json = await fetchJsonData(
    //   "https://assets.hiredly.com/cms-staging/json-file/event_banner_content_sg.json"
    // );

    // const content_my_new = isStaging ? content_my : content_my_json;
    // const content_sg_new = isStaging ? content_sg : content_sg_json;

    const isMalaysia = process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "my";

    let response;
    if (isMalaysia) {
      response = content_my;
    } else {
      response = content_sg;
    }

    const { hbhf } = response || {};

    setData(hbhf);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const onButtonClick = (buttonCTA) => {
    triggerEmployerSignUp(buttonCTA);
  };

  const posthog = usePostHog();
  const buttonColour = "yellow";

  function triggerEmployerSignUp(buttonText) {
    openEmployerSignUp({
      posthog,
      buttonCTA: buttonText,
      buttonColour: buttonColour,
      section: "promo",
    });
  }

  if (data?.eventName) {
    const cmsAssetBase = "https://assets.hiredly.com/cms";

    // Determine image URL based on screen size and event type
    const getImageUrl = () => {
      return data?.imageUpload?.data?.attributes?.url;
    };

    const contentBg =
      "https://assets.wobbjobs.com/images/employer_landing/ELP-bg.png";

    return (
      <GridStyledHireBetter
        id="hbhf"
        sx={{
          backgroundImage: `url(${contentBg})`,
          backgroundSize: "contain", // or 'auto' if you want the image to keep its original size
          backgroundRepeat: "repeat",
          backgroundPosition: "center",
          backgroundColor: "none",
        }}
      >
        <HireBetterOuterCard>
          <HireBetterCard>
            <Grid
              sx={{
                display: "flex",
                justifyContent: "center",
                borderRadius: "16px",
              }}
            >
              <HireBetterImage src={getImageUrl()} width={431} height={300} />
            </Grid>

            <HireBetterUpperContainer>
              <Grid
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  width: "100%",
                  alignItems: belowTablet ? "center" : "flex-start",
                }}
              >
                <Grid
                  sx={(theme) => ({
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                    width: "100%",
                    alignItems: belowTablet ? "center" : "flex-start",
                  })}
                >
                  <HireBetterEventName
                    sx={{
                      "& p": {
                        margin: 0,
                      },
                    }}
                    dangerouslySetInnerHTML={{
                      __html: data?.eventName,
                    }}
                  ></HireBetterEventName>
                  <HireBetterEventHeadline>
                    {data?.eventHeadline}
                  </HireBetterEventHeadline>
                </Grid>

                <HireBetterEventDescription
                  sx={{
                    "& p": {
                      margin: 0,
                    },
                  }}
                  dangerouslySetInnerHTML={{
                    __html: data?.eventDescription,
                  }}
                />
              </Grid>
              <HireBetterButtonContainer>
                <HireBetterCTA
                  onClick={() =>
                    onButtonClick(
                      belowTablet
                        ? data?.ctaButtonCopyMobile
                        : data?.ctaButtonCopy
                    )
                  }
                >
                  {belowTablet
                    ? data?.ctaButtonCopyMobile
                    : data?.ctaButtonCopy}
                </HireBetterCTA>
              </HireBetterButtonContainer>
            </HireBetterUpperContainer>
          </HireBetterCard>
        </HireBetterOuterCard>
      </GridStyledHireBetter>
    );
  }
}
